import { bool, string } from 'prop-types';
import React, { useRef } from 'react';
import { useNavigate } from 'react-router-dom';

import HorizontalScroll from '@components/HorizontalScroll';

import useTrendResearchFilterParams from '@features/trend-research/hooks/useTrendResearchFilterParams';
import useKeyDesigns from '@features/trend-research/hooks/useTrendResearchKeyDesigns';
import EmptyState from '@features/trend-research/components/common/EmptyState';
import {
	Card,
	CardContent,
	FabricImageContainer,
	TopBar
} from '@features/trend-research/components/common/TrendCard';

import { useInsightSummary } from '@store/reducers/trend-research/TrendResearchReducer';

import { processDecimalValue } from '@utils/Util';

const KeyFabrics = ({ isSummaryCountSet, source }) => {
	const navigate = useNavigate();
	const scrollRef = useRef(null);
	const summaryCounts = useInsightSummary();
	const { queryParams } = useTrendResearchFilterParams();

	const { designs, showHorizontalScroll } = useKeyDesigns(
		'key-fabric',
		queryParams,
		summaryCounts,
		'noOfFabrics',
		isSummaryCountSet,
		scrollRef
	);

	const renderCards = () => {
		const handleRoute = (selectedItem) => {
			navigate(`/trends/details${queryParams}`, {
				state: {
					selectedItem,
					type: 'key-fabric',
					source
				}
			});
		};

		return designs?.map((item, idx) => {
			const [mainImage, ...images] = item?.imageUrlList || [];
			const contents = {
				title: item.fabricName.replaceAll('+', ' + '),
				itemCount: item.fabricCount,
				percentage: summaryCounts?.noOfProducts
					? processDecimalValue((item.fabricCount / summaryCounts.noOfProducts) * 100) + '%'
					: `0%`
			};
			return (
				<React.Fragment key={`fabric_${idx}`}>
					<Card
						className="single-fabric-item cursor-pointer"
						onClick={() =>
							handleRoute({ ...item, percentage: contents.percentage, isTop: idx === 0 })
						}
					>
						<TopBar topText={idx === 0} />
						<FabricImageContainer mainImage={mainImage} images={images} />
						<CardContent additionalClasses="" details={contents} tooltipSize={11} />
					</Card>
				</React.Fragment>
			);
		});
	};

	return (
		<div className="key-fabric-section mt-3 trend-padding scrollbar-on-hover">
			<div className="section-title pb-3 d-flex align-items-center justify-content-between">
				<p className="semibold-16 gray_dark_01 d-flex align-items-center">
					<img src={`${process.env.PUBLIC_URL}/icons/flag/fabric.svg`} />
					<span className="pl-1"> Key Fabric</span>
				</p>
			</div>
			{designs.length > 0 ? (
				<div className="d-flex key-slider trending-slider scroll-x-label" ref={scrollRef}>
					{showHorizontalScroll && <HorizontalScroll elementReference={scrollRef.current} />}
					{renderCards()}
				</div>
			) : (
				<EmptyState />
			)}
		</div>
	);
};

KeyFabrics.propTypes = {
	isSummaryCountSet: bool.isRequired,
	source: string.isRequired
};

export default KeyFabrics;
